






















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Notification } from '@/store/types'
import { Mutation } from 'vuex-class'
import moment from 'moment'

/**
 * Tarjeta de notificación del centro de notificaciones
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class NotificationCard extends Vue {

    /**
     * Notificación actual
     */
    @Prop({required: true, type: Notification})
    public value: Notification

    /**
     * Elimina una notificación en base a su identificador
     */
    @Mutation('deleteNotification')
    public deleteNotification: (id: string) => void

    get fancyDate (): string {
        const date = this.value.timestamp
        const minutes = date.getMinutes() > 10 ? date.getMinutes() : `0${date.getMinutes()}`

        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${minutes}`
    }
}
